import { IdGenerator } from '../domain/ports/id';

// Default ID generator preserves current behavior (random base36 substring)
export const defaultId: IdGenerator = {
  makeId(): string {
    return Math.random().toString(36).substr(2, 9);
  },
};

